import numeral from "numeral";

export const formatNumber = (value: number | null | undefined | string, format = "(0,0.00)") => {
	return numeral(value).format(format);
};

export const formatMarkupRate = (value: string | null | undefined) => {
    if (!value || value === '1.0') return 'None';
    const percentage = parseFloat(value);
    return formatNumber(percentage, "0,0.0") ;
};